// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"e0ab9d27","453":"f8a58ced"}[chunkId] + ".chunk.js";
};